import { compareVersion } from '@griply/utils';
import React, { Suspense } from 'react';
import { useElectron } from 'shared/hooks/use-is-mac';

import {
  CreateTaskShortcut,
  LoadingCreateTaskShortcut,
} from './create-task-shortcut';
import { CreateTaskShortcutFallback } from './create-task-shortcut-fallback';

export const QuickEntrySettings: React.FC = () => {
  const { version: electronVersion } = useElectron();

  if (electronVersion && compareVersion(electronVersion, '2.0.0') > 0) {
    return (
      <Suspense fallback={<LoadingCreateTaskShortcut />}>
        <CreateTaskShortcut />
      </Suspense>
    );
  }

  return <CreateTaskShortcutFallback />;
};
